import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_3xl,
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.SaasPromoOrContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${spacing(10)};
    margin: auto;
    padding: ${spacing(12)};
    max-width: 556px;

    color: ${text_colorTextPrimary};

    & .title {
      ${font_3xl};
      font-family: ${font_family_weight_medium};
      text-align: center;
    }

    & .description {
      ${font_lg};
      font-family: ${font_family_weight_regular};
      text-align: center;
      color: ${text_colorTextSecondary};
    }

    & .disclaimer {
      ${font_md};
      font-family: ${font_family_weight_regular};
      text-align: center;
      color: ${text_colorTextSecondary};

      & .underline-link {
        text-decoration: underline;
      }
    }
  }
`
